import {FC, useEffect, useRef, useState} from 'react'
import {CSSTransition} from 'react-transition-group'
import {Account} from 'pages/settings/account'
import {Billing} from 'pages/settings/billing'
import {SettingsSidebarId} from 'pages/settings/config'
import {Deactivation} from 'pages/settings/deactivation'
import {EditProfile} from 'pages/settings/editProfile'
import {Notifications} from 'pages/settings/notifications'
import {names} from 'shared/lib'
import {ArrowLeft} from 'shared/ui/icons'
import {Modal} from 'shared/ui/modal'
import {BottomMenu} from 'widgets/bottomMenu'
import styles from './styles.module.scss'

type ContentMobileProps = {
  selectedId?: SettingsSidebarId
  onClose: () => void
}

export const ContentMobile: FC<ContentMobileProps> = ({
  selectedId,
  onClose
}) => {
  const popupRef = useRef<HTMLDivElement>(null)
  const [isOpenModal, setIsOpenModal] = useState<boolean>(selectedId !== undefined)

  const onCloseClickHandler = () => {
    setIsOpenModal(false)
    setTimeout(() => {
      onClose()
    }, Number(styles.animateCloseModalTimeMs))
  }

  const getTitle = () => {
    switch (selectedId || 0) {
    case SettingsSidebarId.EDIT_PROFILE:
      return 'Edit profile'
    case SettingsSidebarId.ACCOUNT:
      return 'Account'
    case SettingsSidebarId.NOTIFICATIONS:
      return 'Notifications'
    case SettingsSidebarId.BILLING:
      return 'Billing'
    case SettingsSidebarId.DEACTIVATION:
      return 'Deactivation'
    }
  }

  useEffect(() => {
    if (selectedId === undefined) return setIsOpenModal(false)

    const timeout = setTimeout(() => {
      setIsOpenModal(true)
    }, Number(styles.animateCloseModalTimeMs))

    return () => {
      clearTimeout(timeout)
    }
  }, [selectedId])


  return (
    <CSSTransition
      classNames={{
        enterDone: styles.fade_enter,
        exitDone: styles.fade_exit
      }}
      in={isOpenModal}
      timeout={{enter: 0, exit: Number(styles.animateCloseModalTimeMs)}}
      unmountOnExit
      nodeRef={popupRef}
    >
      <Modal
        disableEnforceFocus
        open
        classes={{backdrop: styles.modalBackdrop}}
      >
        <div className={styles.wrapperContentMobile}>
          <div className={styles.contentMobile} ref={popupRef}>
            <div className={styles.header}>
              <div className={styles.backBtn} onClick={onCloseClickHandler}>
                <ArrowLeft />
              </div>
              <h2 className={styles.headerTitle}>{getTitle()}</h2>
            </div>
            <div className={names(styles.content, styles.customScroll)}>
              <Content itemId={selectedId || 0} />
            </div>
            <BottomMenu />
          </div>
        </div>
      </Modal>
    </CSSTransition>
  )
}

type ContentProps = {
  itemId: SettingsSidebarId
}

const Content: FC<ContentProps> = ({itemId}) => {
  switch (itemId) {
  case SettingsSidebarId.EDIT_PROFILE:
    return <EditProfile />
  case SettingsSidebarId.ACCOUNT:
    return <Account />
  case SettingsSidebarId.NOTIFICATIONS:
    return <Notifications />
  case SettingsSidebarId.BILLING:
    return <Billing />
  case SettingsSidebarId.DEACTIVATION:
    return <Deactivation />
  }
}
